import React from "react";
import { Link } from "react-router-dom";
import { Construction, ArrowLeft } from "lucide-react";

// Clean placeholder for modules activated in later development phases (Step 2+).
export function PagePlaceholder({ title, description, phase = "next development phase", children }) {
  return (
    <div className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid="page-placeholder">
      <div className="inline-flex h-16 w-16 rounded-2xl bg-accent text-secondary items-center justify-center mb-6">
        <Construction size={30} />
      </div>
      <h1 className="text-3xl sm:text-4xl font-serif font-bold text-stone-900">{title}</h1>
      {description && <p className="mt-3 text-stone-600">{description}</p>}
      <p className="mt-4 inline-block text-sm font-medium text-secondary bg-secondary/5 border border-secondary/20 rounded-full px-4 py-1.5">
        This module will be activated in the {phase}.
      </p>
      {children && <div className="mt-8 text-left">{children}</div>}
      <div className="mt-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-stone-700 hover:text-secondary"
        >
          <ArrowLeft size={15} /> Back to Home
        </Link>
      </div>
    </div>
  );
}
